import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
// import { encryptQueryString } from "../../utils/API/requestMiddleware"
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString } from "../../utils/API/requestMiddleware";

const reportAPI = createApi({
    reducerPath: 'reportAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getEmployerBondsReport: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Report/EmployerBondsReport?Type=${details.type}&Date=${details.date}`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getEmployerDemographicReport: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Report/EmployerDemographicsReport?EmployerType=${details.companyTypeID.toString()}&WorkType=${details.workTypeID.toString()}`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getEmployerListReport: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Report/EmployerListReport?BeginDate=${details.startDate}&CraftID=${details.craftID}`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getContractorsBySignedDateReport: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Report/ContractorsbySignedDateReport?BeginDate=${details.startDate}&EndDate=${details.endDate}&CraftID=${details.craftID}&LocalID=${details.localID}`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getContractorsByCraftReport: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Report/ContractorsbyCraftReport?Date=${details.startDate}&CraftID=${details.craftID}&LocalID=${details.localID}`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getContractorsByAssociationReport: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Report/ContractorsbyAssociationReport?Date=${details.startDate}&AssociationID=${details.associationID}&LocalID=${details.localID}`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getUnsignedEmployersReport: builder.query({
            query: (details) => ({
                url: encryptQueryString(`/Report/UnsignedEmployersReport?StartDate=${details.startDate}&EndDate=${details.endDate}&CraftID=${details.craftID}`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getContractorsBySignedDateAddressReport: builder.query({
            query: () => ({
                url: encryptQueryString(`/Report/ContractorsbySignedDateAddressReport`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getContractorsByCraftAddressReport: builder.query({
            query: () => ({
                url: encryptQueryString(`/Report/ContractorsbyCraftAddressReport`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getContractorsByAssociationAddressReport: builder.query({
            query: () => ({
                url: encryptQueryString(`/Report/ContractorsbyAssociationAddressReport`),
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
});

export const {
    useLazyGetEmployerBondsReportQuery,
    useLazyGetEmployerDemographicReportQuery,
    useLazyGetEmployerListReportQuery,
    useLazyGetContractorsBySignedDateReportQuery,
    useLazyGetContractorsByCraftReportQuery,
    useLazyGetContractorsByAssociationReportQuery,
    useLazyGetUnsignedEmployersReportQuery,
    useLazyGetContractorsBySignedDateAddressReportQuery,
    useLazyGetContractorsByCraftAddressReportQuery,
    useLazyGetContractorsByAssociationAddressReportQuery,
} = reportAPI;

export default reportAPI;